import EnterpriseObjectMemberMetadata from "../../EnterpriseObjectMemberMetadata";
import EnterpriseObjectMetadata from "../../EnterpriseObjectMetadata";

// Relationship edges for the detail page's Detail tab. Standalone rather than a member of
// ObjectRevision's EnterpriseObject: edges reference the LOGICAL object, so they are queried by
// ParentUSID and must not re-query every time a different revision is selected.
class ObjectRelationshipEnterpriseObjectMetadata extends EnterpriseObjectMetadata {

    constructor() {
        super();

        this.name = "ObjectRelationship";
        this.primaryEnterpriseComponent = "ObjectRelationship";

        const eom: EnterpriseObjectMemberMetadata = new EnterpriseObjectMemberMetadata();
        eom.name = "ObjectRelationship";
        eom.enterpriseComponent = "ObjectRelationship";
        eom.relationship = undefined;
        this.enterpriseComponentMembers.set(eom.name, eom);
    }
}

export default ObjectRelationshipEnterpriseObjectMetadata;
